import { AvailabilityOrder } from '@libs/trip-planner-interfaces';
import type {
  DecimalRangeType,
  StringRangeType,
} from '@libs/trip-planner-interfaces';

import { BaseIngredient } from './baseIngredient';
import type { BookableTransportIngredientType } from './typeGuards';

export interface BookableTransportIngredientFilters {
  carrierFilters: string[];
  departureTimeFilters?: StringRangeType;
  arrivalTimeFilters?: StringRangeType;
  maxDurationInHours?: number;
  priceFilters?: DecimalRangeType;
}

export const DEFAULT_AVAILABILITY_ORDER_SUGGESTION = AvailabilityOrder.Popular;

export class BookableTransportIngredient<
  T extends BookableTransportIngredientType = BookableTransportIngredientType,
> extends BaseIngredient<T> {
  public static get defaultFilters(): BookableTransportIngredientFilters {
    return {
      carrierFilters: [],
      arrivalTimeFilters: undefined,
      departureTimeFilters: undefined,
      maxDurationInHours: undefined,
      priceFilters: undefined,
    };
  }

  public isManuallySelected = false;
  public isConfirmed = false;

  public transportIds?: string[];

  public fromPortDisplayText?: string;
  public toPortDisplayText?: string;
  public fromPort?: string;
  public toPort?: string;
  public fromPortText?: string;
  public toPortText?: string;

  public filters: BookableTransportIngredientFilters =
    BookableTransportIngredient.defaultFilters;

  public availabilityOrder: AvailabilityOrder =
    DEFAULT_AVAILABILITY_ORDER_SUGGESTION;

  constructor(public readonly ingredientType: T) {
    super(ingredientType);
  }

  public isIngredientCorrect(): boolean {
    return !!this.fromPort && !!this.toPort;
  }
}
